<template>
  <v-navigation-drawer
    id="appDrawer"
    clipped
    app
    v-model="drawer"
    color="grey lighten-4"
  >
    <div style="padding: 20px;" class="hidden-lg-and-up">
      <v-img
        @click="toDashBoard"
        :to="{ name: 'Dashboard' }"
        max-height="30"
        contain
        :src="computeLogo"
      ></v-img>
    </div>
    <v-list-item two-line :to="{ name: 'Profile' }">
      <v-list-item-avatar>
        <img v-if="userPicture()" :src="userPicture()" />
        <v-icon v-else size="35">fa-user-circle</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ userName() }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <!-- <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings"> -->
    <v-list dense expand>
      <template v-for="(item, i) in menus">
        <!--group with subitems-->
        <v-list-group
          v-if="item.items"
          :key="item.name"
          :group="item.group"
          :prepend-icon="item.icon"
          no-action="no-action"
        >
          <v-list-tile slot="activator" ripple="ripple">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <template v-for="(subItem, i) in item.items">
            <!--sub group-->
            <v-list-group
              v-if="subItem.items"
              :key="subItem.name"
              :group="subItem.group"
              sub-group="sub-group"
            >
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                v-for="(grand, i) in subItem.children"
                :key="i"
                :to="genChildTarget(item, grand)"
                :href="grand.href"
                ripple="ripple"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
            <!--child item-->
            <v-list-tile
              v-else
              :key="i"
              :to="genChildTarget(item, subItem)"
              :href="subItem.href"
              :disabled="subItem.disabled"
              :target="subItem.target"
              ripple="ripple"
            >
              <v-list-tile-content>
                <v-list-tile-title
                  ><span>{{ subItem.title }}</span></v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-action v-if="subItem.action">
                <v-icon :class="[subItem.actionClass || 'success--text']">{{
                  subItem.action
                }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list-group>
        <v-subheader v-else-if="item.header" :key="i">{{
          item.header
        }}</v-subheader>
        <v-divider v-else-if="item.divider" :key="i"></v-divider>
        <!--top-level link-->
        <v-list-item
          v-else
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="item.name"
          v-show="checkPluginAccess(item)"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon small>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <!-- </vue-perfect-scrollbar>         -->
    <template v-slot:append>
      <div class="pa-2">
        <small>5.6.4</small>
      </div>
    </template>
  </v-navigation-drawer>
</template>
<script>
import menu from '@/api/menu';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  name: 'app-drawer',
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    mini: false,
    drawer: false,
    menus: menu,
    scrollSettings: {
      maxScrollbarLength: 160,
    },
  }),
  computed: {
    computeGroupActive() {
      return true;
    },
    computeLogo() {
      return '/static/logo-ecotrace-a.png';
    },

    sideToolbarColor() {
      return this.$vuetify.options.extra.sideNav;
    },
  },
  created() {
    window.getApp.$on('APP_DRAWER_TOGGLED', () => {
      this.drawer = !this.drawer;
    });
  },

  methods: {
    checkPluginAccess(item) {
      const { requiredPlugin } = item;

      let hasAccess = true;

      if (requiredPlugin) {
        const { activePlugins = [] } = this.$auth.user();

        const userAccess = activePlugins.find((p) => p === requiredPlugin);

        hasAccess = (userAccess && true) || false;
      }

      return hasAccess;
    },

    userPicture() {
      if (this.$auth.user().picture) {
        return this.$auth.user().picture;
      }
      return null;
    },
    userName() {
      if (this.$auth.user().name) {
        return this.$auth.user().name;
      }
      return '';
    },
    genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      return { name: `${item.group}/${subItem.name}` };
    },
    toDashBoard() {
      this.$router.push({ name: 'Dashboard' });
    },
  },
};
</script>

<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';

// #appDrawer
//   overflow: hidden
//   .drawer-menu--scroll
//     height: calc(100vh - 48px)
//     overflow: auto
</style>

<style lang="scss" scoped>
#appDrawer::v-deep {
  .v-list-item__action {
    margin-right: 20px;

    .icon-farm:before {
      font-size: 90%;
    }
  }
}
</style>
